import React from "react";
import './App.css';
import Screen from "./components/Screen";
import ButtonParent from './components/ButtonParent';
import ThemeChanger from './components/ThemeChanger';
import { evaluate } from "mathjs";


function App(props) {
  // const containerDiv = {
  //   position: "absolute",
  //   top: "50%",
  //   left: "50%",
  //   transform: "translate(-50%, -50%)",
  //   width: "30%"
  // }
  const blueTheme = {
    rootBackgroundColor: "hsl(222, 26%, 31%)",
    
    deleteBackgroundColor: "hsl(225, 21%, 49%)",
    resetBackgroundColor : "hsl(225, 21%, 49%)",
    deleteShadowColor : "1px 5px hsl(224, 28%, 35%)",
    resetShadowColor : "1px 5px hsl(224, 28%, 35%)",
    equalsBackgroundColor: "hsl(6, 63%, 50%)",
    equalsShadowColor: "1px 5px hsl(6, 70%, 34%)",
    deleteColor : "white",
    resetColor : "white",
    equalsColor : "white",
    numbersColor : "hsl(221, 14%, 31%)",
    numbersBackgroundColor : "hsl(30, 25%, 89%)",
    numbersShadowColor : "1px 5px hsl(28, 16%, 65%)",

    buttonParentBackgroundcolor : "hsl(223, 31%, 20%)",

    screenBackgroundColor : "hsl(224, 36%, 15%)",
    screenColor : "white",

    logoColor : "white",
    themesColor : "white",
    grayColor : "white",
    violetColor : "white",
    blueColor : "hsl(6, 63%, 50%)"
  }
  const grayTheme = {
    rootBackgroundColor: "hsl(0, 0%, 90%)",
    
    deleteBackgroundColor: "hsl(185, 42%, 37%)",
    resetBackgroundColor: "hsl(185, 42%, 37%)",
    deleteShadowColor : "1px 5px hsl(185, 58%, 25%)",
    resetShadowColor : "1px 5px hsl(185, 58%, 25%)",
    equalsBackgroundColor: "hsl(25, 98%, 40%)",
    equalsShadowColor: "1px 5px hsl(25, 99%, 27%)",
    deleteColor : "white",
    resetColor : "white",
    equalsColor : "white",
    numbersColor : "hsl(60, 10%, 19%)",
    numbersBackgroundColor : "hsl(45, 7%, 89%)",
    numbersShadowColor : "1px 5px hsl(35, 11%, 61%)",
    buttonParentBackgroundcolor : "hsl(0, 5%, 81%)",

    screenBackgroundColor : "hsl(0, 0%, 93%)",
    screenColor : "hsl(60, 10%, 19%)",

    logoColor : "hsl(60, 10%, 19%)",
    themesColor : "hsl(60, 10%, 19%)",
    grayColor : "hsl(6, 63%, 50%)",
    violetColor : "hsl(60, 10%, 19%)",
    blueColor : "hsl(60, 10%, 19%)",
  }
  const violetTheme = {
    rootBackgroundColor: "hsl(268, 75%, 9%)",
    
    deleteBackgroundColor: "hsl(281, 89%, 26%)",
    resetBackgroundColor : "hsl(281, 89%, 26%)",
    deleteShadowColor : "1px 5px hsl(285, 91%, 52%)",
    resetShadowColor : "1px 5px hsl(285, 91%, 52%)",
    equalsBackgroundColor: "hsl(176, 100%, 44%)",
    equalsShadowColor: "1px 5px hsl(177, 92%, 70%)",
    deleteColor : "hsl(0, 0, 100%)",
    resetColor : "hsl(0, 0, 100%)",
    equalsColor : "hsl(198, 20%, 13%)",
    numbersColor : "hsl(52, 100%, 62%)",
    numbersBackgroundColor : "hsl(268, 47%, 21%)",
    numbersShadowColor : "1px 5px hsl(290, 70%, 36%)",

    buttonParentBackgroundcolor : "hsl(268, 71%, 12%)",

    screenBackgroundColor : "hsl(268, 71%, 12%)",
    screenColor : "hsl(52, 100%, 62%)",

    logoColor : "hsl(52, 100%, 62%)",
    themesColor : "hsl(52, 100%, 62%)",
    grayColor : "hsl(52, 100%, 62%)",
    violetColor : "hsl(176, 100%, 44%)",
    blueColor : "hsl(52, 100%, 62%)"
  }


  const[screenInput, setScreenInput] = React.useState("-");
  const[currentColour, setCurrentColour] = React.useState(blueTheme);

  function numberIsclicked(event){
    screenInput === "-" ? setScreenInput(event.target.id) : setScreenInput(screenInput + "" + event.target.id);
  }
  function reset(){
    setScreenInput("-")
  }

  function changeToBlue(){
    setCurrentColour(blueTheme);
    props.rootElement.style.backgroundColor = "hsl(222, 26%, 31%)";
    document.getElementById("creator").style.color = "white";
  }
  function changeToGray(){
    setCurrentColour(grayTheme);
    props.rootElement.style.backgroundColor  = "hsl(0, 0%, 90%)";
    document.getElementById("creator").style.color = "hsl(60, 10%, 19%)";
  }
  function changeToViolet(){
    setCurrentColour(violetTheme);
    props.rootElement.style.backgroundColor = "hsl(268, 75%, 9%)";
    document.getElementById("creator").style.color = "hsl(52, 100%, 62%)";
  }

  function equals(){
    try{
      setScreenInput(evaluate(screenInput));
    }
    catch(err){
      alert("undefined computation!");
      reset();
    }
  }
  function deleteLastNumber(){
    const lengthOfInput = screenInput.length;
    try{
      lengthOfInput === 1 ? reset() : setScreenInput(screenInput.substring(0, lengthOfInput - 1));
    }
    catch(err){
      alert("undefined deletion");
      reset();
    }
  }

  

  return (
    
    <div className = "container" id = "container-div" >
      <div id = "top-component">
        <div id = "logoName" style = {{color:currentColour.logoColor}}>calc</div>
        <ThemeChanger 
          blue = {changeToBlue} 
          gray = {changeToGray} 
          violet = {changeToViolet}
          grayColor = {currentColour.grayColor}
          blueColor = {currentColour.blueColor}
          violetColor = {currentColour.violetColor}
          themesColor = {currentColour.themesColor}
        />
      </div>
      <Screen 
        inputValue  = {screenInput}
        background = {currentColour.screenBackgroundColor}
        color = {currentColour.screenColor}
      />
      <ButtonParent 
        getNumber = {numberIsclicked} 
        reset = {reset} 
        equals = {equals}
        delete=  {deleteLastNumber}
        deleteBackgroundColor = {currentColour.deleteBackgroundColor}
        resetBackgroundColor =  {currentColour.resetBackgroundColor}
        equalsBackgroundColor = {currentColour.equalsBackgroundColor}
        deleteColor  = {currentColour.deleteColor}
        resetColor  = {currentColour.resetColor}
        equalsColor  = {currentColour.equalsColor}
        numbersColor =  {currentColour.numbersColor}
        numbersBackgroundColor  = {currentColour.numbersBackgroundColor}
        numbersShadowColor = {currentColour.numbersShadowColor}
        buttonParentBackgroundcolor = {currentColour.buttonParentBackgroundcolor}
        equalsShadowColor = {currentColour.equalsShadowColor}
        resetShadowColor = {currentColour.resetShadowColor}
        deleteShadowColor = {currentColour.deleteShadowColor}
      />
    </div>
  );
}

export default App;
